import { useQuery } from '@tanstack/react-query'
import { Paciente } from '../../pagesApp/loginApp.types'
import { api } from '../api'

const fetchAllPacientes = async (): Promise<Paciente[]> => {
	const response = await api.get('/api/pacientes/all')
	return response.data
}

export const usePacientes = () => {
	return useQuery<Paciente[], Error>({
		queryKey: ['pacientes'],
		queryFn: () => fetchAllPacientes(),
		enabled: true
	})
}

const fetchMiPerfilPaciente = async (): Promise<Paciente> => {
	const response = await api.get('/api/pacientes/mi-perfil')
	return response.data
}

export const useMiPerfilPaciente = () => {
	return useQuery<Paciente, Error>({
		queryKey: ['mi-perfil-paciente'],
		queryFn: () => fetchMiPerfilPaciente(),
		enabled: true
	})
}

const fetchPaciente = async (dni: string): Promise<Paciente> => {
	const response = await api.get(`/api/pacientes/${dni}`)
	return response.data
}
export const usePaciente = (dni: string) => {
	return useQuery<Paciente, Error>({
		queryKey: ['paciente', dni],
		queryFn: () => fetchPaciente(dni),
		enabled: dni !== undefined && dni !== null && dni !== ''
	})
}